import layeredSoilAttribute from './layeredSoilAttribute';

const cationExchangeCapacity = (allLayers: boolean) =>
  layeredSoilAttribute({
    allLayers,
    key: 'Cation Exchange Capacity: CEC-7',
    ratingCol: {
      displayString: 'Capacity (milliequivalents/100g)',
      accessor: 'mapUnitRatingString',
    },
    ruleId: '28',
    units: 'milliequivalents per 100g',
  });

export const CATION_EXCHANGE_ALL_LAYERS = cationExchangeCapacity(true);
export const CATION_EXCHANGE_SURFACE_LAYER = cationExchangeCapacity(false);
